import { render } from "./TypeDocuments.vue?vue&type=template&id=872f3cb2"
import script from "./TypeDocuments.vue?vue&type=script&lang=js"
export * from "./TypeDocuments.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__